import { render } from "./followUpRecords.vue?vue&type=template&id=1c8e3bee&scoped=true"
import script from "./followUpRecords.vue?vue&type=script&lang=js"
export * from "./followUpRecords.vue?vue&type=script&lang=js"

import "./followUpRecords.vue?vue&type=style&index=0&id=1c8e3bee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8e3bee"]])

export default __exports__